import { render, staticRenderFns } from "./CyCrkManageDetail.vue?vue&type=template&id=25939b96&scoped=true"
import script from "./CyCrkManageDetail.vue?vue&type=script&lang=js"
export * from "./CyCrkManageDetail.vue?vue&type=script&lang=js"
import style0 from "./CyCrkManageDetail.vue?vue&type=style&index=0&id=25939b96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25939b96",
  null
  
)

export default component.exports